// //30-12-2025
// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { X, Save } from "lucide-react";
// // import "../../css/common/form-modal.css";
// import '../../css/commonFormModal.css';

// export default function DealForm({
//   deal,
//   leads = [],
//   properties = [],
//   onSubmit,
//   onCancel,
//   isLoading,
// }) {
//   const [formData, setFormData] = useState(
//     deal || {
//       dealName: "",
//       leadID: "",
//       propertyID: "",
//       dealValue: "",
//       commissionAmout: "",
//       stage: "negotiation",
//       winProbability: "",
//       expectedCloseDate: "",
//       assignedtoEmail: "",
//       notes: "",
//     }
//   );

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const payload = {
//       ...formData,
//       dealValue: Number(formData.dealValue),
//       commissionAmout: formData.commissionAmout
//         ? Number(formData.commissionAmout)
//         : undefined,
//       winProbability: formData.winProbability
//         ? Number(formData.winProbability)
//         : undefined,
//     };

//     onSubmit(payload);
//   };

//   return (
//     <motion.div
//       className="form-overlay"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//     >
//       <motion.div
//         className="form-card"
//         initial={{ scale: 0.95, y: 20 }}
//         animate={{ scale: 1, y: 0 }}
//         exit={{ scale: 0.95, y: 20 }}
//       >
//         {/* HEADER */}
//         <div className="form-header">
//           <h2>{deal ? "Edit Deal" : "Create New Deal"}</h2>
//           <button className="icon-btn" onClick={onCancel}>
//             <X size={18} />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit}>
//           {/* BODY */}
//           <div>
//             {/* Deal Name */}
//             <div className="form-group">
//               <label>Deal Name *</label>
//               <input
//                 type="text"
//                 name="dealName"
//                 value={formData.dealName}
//                 onChange={handleChange}
//                 required
//                 placeholder="Downtown Apartment Deal"
//               />
//             </div>

//             {/* Lead & Property */}
//             <div className="grid-2">
//               <div className="form-group">
//                 <label>Lead *</label>
//                 <select
//                   name="leadID"
//                   value={formData.leadID}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select lead</option>
//                   {leads.map((lead) => (
//                     <option key={lead._id} value={lead._id}>
//                       {lead.full_name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>Property *</label>
//                 <select
//                   name="propertyID"
//                   value={formData.propertyID}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select property</option>
//                   {properties.map((property) => (
//                     <option key={property._id} value={property._id}>
//                       {property.propertyName}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Deal Value & Commission */}
//             <div className="grid-2">
//               <div className="form-group">
//                 <label>Deal Value *(In Rupees)</label>
//                 <input
//                   type="number"
//                   name="dealValue"
//                   value={formData.dealValue}
//                   onChange={handleChange}
//                   required
//                   placeholder="500000"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Commission Amount(In Rupees)</label>
//                 <input
//                   type="number"
//                   name="commissionAmout"
//                   value={formData.commissionAmout}
//                   onChange={handleChange}
//                   placeholder="15000"
//                 />
//               </div>
//             </div>

//             {/* Stage & Probability */}
//             <div className="grid-2">
//               <div className="form-group">
//                 <label>Stage</label>
//                 <select
//                   name="stage"
//                   value={formData.stage}
//                   onChange={handleChange}
//                 >
//                   <option value="negotiation">Negotiation</option>
//                   <option value="documentation">Documentation</option>
//                   <option value="payment_pending">Payment Pending</option>
//                   <option value="closed_won">Closed Won</option>
//                   <option value="closed_lost">Closed Lost</option>
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>Win Probability (%)</label>
//                 <input
//                   type="number"
//                   name="winProbability"
//                   min="0"
//                   max="100"
//                   value={formData.winProbability}
//                   onChange={handleChange}
//                   placeholder="75"
//                 />
//               </div>
//             </div>

//             {/* Date & Assigned */}
//             <div className="grid-2">
//               <div className="form-group">
//                 <label>Expected Close Date</label>
//                 <input
//                   type="date"
//                   name="expectedCloseDate"
//                   value={formData.expectedCloseDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Assigned To (Email)</label>
//                 <input
//                   type="email"
//                   name="assignedtoEmail"
//                   value={formData.assignedtoEmail}
//                   onChange={handleChange}
//                   placeholder="agent@zenrealty.com"
//                 />
//               </div>
//             </div>

//             {/* Notes */}
//             <div className="form-group">
//               <label>Notes</label>
//               <textarea
//                 name="notes"
//                 rows="3"
//                 value={formData.notes}
//                 onChange={handleChange}
//                 placeholder="Additional deal notes..."
//               />
//             </div>
//           </div>

//           {/* FOOTER */}
//           <div className="form-footer">
//             <button
//               type="button"
//               className="btn-outline"
//               onClick={onCancel}
//             >
//               Cancel
//             </button>

//             <button
//               type="submit"
//               className="btn-primary"
//               disabled={isLoading}
//             >
//               <Save size={16} />
//               {isLoading ? "Saving..." : "Save Deal"}
//             </button>
//           </div>
//         </form>
//       </motion.div>
//     </motion.div>
//   );
// }

// Updated: 06-04-2026
// Changes:
// - Lead & Property fields converted to searchable dropdowns (SearchableSelect)
// - Deal Value & Commission converted to price format (number + unit: Thousands/Lakhs/Crores)
// - step="any" on all number inputs so decimals are accepted
// - Added Yes/No radio button for "Agreement Signed"
// - If "Yes" selected, backend auto-creates a pending Installment payment on deal save

import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { X, Save, Search, ChevronDown } from "lucide-react";
import "../../css/commonFormModal.css";

/* ─────────────────────────────────────────────
   SearchableSelect – generic combobox
───────────────────────────────────────────── */
function SearchableSelect({ name, value, onChange, options, placeholder = "Select..." }) {
  const [open, setOpen]   = useState(false);
  const [query, setQuery] = useState("");
  const ref               = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered      = options.filter((o) => o.label.toLowerCase().includes(query.toLowerCase()));
  const selectedLabel = options.find((o) => o.value === value)?.label || "";

  const handleSelect = (val) => {
    onChange({ target: { name, value: val } });
    setOpen(false);
    setQuery("");
  };

  return (
    <div className="searchable-select" ref={ref}>
      <div
        className={`ss-trigger ${open ? "open" : ""}`}
        onClick={() => setOpen((p) => !p)}
      >
        <span className={selectedLabel ? "ss-value" : "ss-placeholder"}>
          {selectedLabel || placeholder}
        </span>
        <ChevronDown size={14} className={`ss-chevron ${open ? "rotated" : ""}`} />
      </div>

      {open && (
        <div className="ss-dropdown">
          <div className="ss-search">
            <Search size={13} />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search..."
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <ul className="ss-list">
            {filtered.length === 0 && <li className="ss-empty">No results</li>}
            {filtered.map((o) => (
              <li
                key={o.value}
                className={`ss-item ${o.value === value ? "selected" : ""}`}
                onClick={() => handleSelect(o.value)}
              >
                {o.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   Price units config
───────────────────────────────────────────── */
const PRICE_UNITS = [
  { value: "thousands", label: "Thousands", multiplier: 1_000 },
  { value: "lakhs",     label: "Lakhs",     multiplier: 100_000 },
  { value: "crores",    label: "Crores",    multiplier: 10_000_000 },
];

function parsePriceToValueUnit(raw) {
  const num = parseFloat(String(raw));
  if (isNaN(num) || num === 0) return { value: "", unit: "lakhs" };
  if (num >= 10_000_000) return { value: String(+(num / 10_000_000).toFixed(4)), unit: "crores" };
  if (num >= 100_000)    return { value: String(+(num / 100_000).toFixed(4)),     unit: "lakhs" };
  return                        { value: String(+(num / 1_000).toFixed(4)),        unit: "thousands" };
}

function computeRaw(value, unit) {
  if (!value && value !== 0) return null;
  const multiplier = PRICE_UNITS.find((u) => u.value === unit)?.multiplier || 1;
  return parseFloat(value) * multiplier;
}

/* ─────────────────────────────────────────────
   PriceInput – number + unit + preview
───────────────────────────────────────────── */
function PriceInput({ label, valueKey, unitKey, priceState, setPriceState, required = false }) {
  const numVal  = priceState[valueKey] || "";
  const unitVal = priceState[unitKey]  || "lakhs";
  const raw     = computeRaw(numVal, unitVal);
  const preview = numVal
    ? `₹ ${new Intl.NumberFormat("en-IN").format(raw)}`
    : "";

  return (
    <div className="form-group">
      <label>{label}{required ? " *" : ""}</label>
      <div className="budget-input-group">
        <input
          type="number"
          className="budget-number"
          placeholder="0"
          min="0"
          step="any"
          value={numVal}
          onChange={(e) =>
            setPriceState((prev) => ({ ...prev, [valueKey]: e.target.value }))
          }
        />
        <select
          className="budget-unit"
          value={unitVal}
          onChange={(e) =>
            setPriceState((prev) => ({ ...prev, [unitKey]: e.target.value }))
          }
        >
          {PRICE_UNITS.map((u) => (
            <option key={u.value} value={u.value}>{u.label}</option>
          ))}
        </select>
      </div>
      {preview && <span className="budget-preview">{preview}</span>}
    </div>
  );
}

/* ─────────────────────────────────────────────
   Main DealForm component
───────────────────────────────────────────── */
export default function DealForm({
  deal,
  leads = [],
  properties = [],
  onSubmit,
  onCancel,
  isLoading,
}) {
  /* Core form fields */
  const [formData, setFormData] = useState({
    dealName:          deal?.dealName          || "",
    leadID:            deal?.leadID && typeof deal.leadID === 'object' ? deal.leadID._id : deal?.leadID || "",
    propertyID:        deal?.propertyID && typeof deal.propertyID === 'object' ? deal.propertyID._id : deal?.propertyID || "",
    stage:             deal?.stage             || "negotiation",
    winProbability:    deal?.winProbability     || "",
    expectedCloseDate: deal?.expectedCloseDate
      ? deal.expectedCloseDate.slice(0, 10)
      : "",
    assignedtoEmail:   deal?.assignedtoEmail    || "",
    notes:             deal?.notes              || "",
  });

  /* Price UI state – kept separate so the form stays clean */
  const [priceState, setPriceState] = useState({
    dealValue_value:  "",
    dealValue_unit:   "lakhs",
    commission_value: "",
    commission_unit:  "lakhs",
  });

  /* Agreement radio */
  const [agreementSigned, setAgreementSigned] = useState(
    deal?.agreementSigned ?? false
  );

  /* Populate price fields when editing an existing deal */
  useEffect(() => {
    if (deal) {
      if (deal.dealValue) {
        const p = parsePriceToValueUnit(deal.dealValue);
        setPriceState((prev) => ({
          ...prev,
          dealValue_value: p.value,
          dealValue_unit:  p.unit,
        }));
      }
      if (deal.commissionAmout) {
        const p = parsePriceToValueUnit(deal.commissionAmout);
        setPriceState((prev) => ({
          ...prev,
          commission_value: p.value,
          commission_unit:  p.unit,
        }));
      }
    }
  }, []);

  /* Build option lists for SearchableSelect */
  const leadOptions = [
    { value: "", label: "Select lead..." },
    ...leads.map((l) => ({ value: l._id, label: l.full_name })),
  ];

  const propertyOptions = [
    { value: "", label: "Select property..." },
    ...properties.map((p) => ({ value: p._id, label: p.propertyName })),
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const rawDealValue  = computeRaw(priceState.dealValue_value, priceState.dealValue_unit);
    const rawCommission = computeRaw(priceState.commission_value, priceState.commission_unit);

    if (!rawDealValue) {
      alert("Deal Value is required");
      return;
    }
    if (!formData.leadID) {
      alert("Please select a lead");
      return;
    }
    if (!formData.propertyID) {
      alert("Please select a property");
      return;
    }

    const payload = {
      ...formData,
      dealValue:       rawDealValue,
      commissionAmout: rawCommission || undefined,
      winProbability:  formData.winProbability ? Number(formData.winProbability) : undefined,
      agreementSigned,
    };

    onSubmit(payload);
  };

  return (
    <motion.div
      className="form-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="form-card"
        initial={{ scale: 0.95, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.95, y: 20 }}
      >
        {/* HEADER */}
        <div className="form-header">
          <h2>{deal ? "Edit Deal" : "Create New Deal"}</h2>
          <button type="button" className="icon-btn" onClick={onCancel}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div>
            {/* Deal Name */}
            <div className="form-group">
              <label>Deal Name *</label>
              <input
                type="text"
                name="dealName"
                value={formData.dealName}
                onChange={handleChange}
                required
                placeholder="Downtown Apartment Deal"
              />
            </div>

            {/* Lead & Property — searchable dropdowns */}
            <div className="grid-2">
              <div className="form-group">
                <label>Lead *</label>
                <SearchableSelect
                  name="leadID"
                  value={formData.leadID}
                  onChange={handleChange}
                  options={leadOptions}
                  placeholder="Search lead..."
                />
              </div>

              <div className="form-group">
                <label>Property *</label>
                <SearchableSelect
                  name="propertyID"
                  value={formData.propertyID}
                  onChange={handleChange}
                  options={propertyOptions}
                  placeholder="Search property..."
                />
              </div>
            </div>

            {/* Deal Value & Commission — price format */}
            <div className="grid-2">
              <PriceInput
                label="Deal Value"
                valueKey="dealValue_value"
                unitKey="dealValue_unit"
                priceState={priceState}
                setPriceState={setPriceState}
                required
              />
              <PriceInput
                label="Commission Amount"
                valueKey="commission_value"
                unitKey="commission_unit"
                priceState={priceState}
                setPriceState={setPriceState}
              />
            </div>

            {/* Stage & Win Probability */}
            <div className="grid-2">
              <div className="form-group">
                <label>Stage</label>
                <select name="stage" value={formData.stage} onChange={handleChange}>
                  <option value="" disabled>— Select Stage —</option>
                  <option value="negotiation">Negotiation</option>
                  <option value="documentation">Documentation</option>
                  <option value="payment_pending">Payment Pending</option>
                  <option value="closed_won">Closed Won</option>
                  <option value="closed_lost">Closed Lost</option>
                </select>
              </div>

              <div className="form-group">
                <label>Win Probability (%)</label>
                <input
                  type="number"
                  name="winProbability"
                  min="0"
                  max="100"
                  step="any"
                  value={formData.winProbability}
                  onChange={handleChange}
                  placeholder="75"
                />
              </div>
            </div>

            {/* Expected Close Date & Assigned To */}
            <div className="grid-2">
              <div className="form-group">
                <label>Expected Close Date</label>
                <input
                  type="date"
                  name="expectedCloseDate"
                  value={formData.expectedCloseDate}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Assigned To (Email)</label>
                <input
                  type="email"
                  name="assignedtoEmail"
                  value={formData.assignedtoEmail}
                  onChange={handleChange}
                  placeholder="agent@example.com"
                />
              </div>
            </div>

            {/* Agreement Signed — Yes / No */}
            <div className="form-group">
              <label>Agreement Signed?</label>
              <div className="radio-group">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="agreementSigned"
                    checked={agreementSigned === true}
                    onChange={() => setAgreementSigned(true)}
                  />
                  Yes
                </label>
                <label className="radio-label">
                  <input
                    type="radio"
                    name="agreementSigned"
                    checked={agreementSigned === false}
                    onChange={() => setAgreementSigned(false)}
                  />
                  No
                </label>
              </div>
              {agreementSigned && (
                <p className="field-hint" style={{ marginTop: "6px" }}>
                  A pending <strong>Installment</strong> payment will be automatically
                  created for this deal.
                </p>
              )}
            </div>

            {/* Notes */}
            <div className="form-group">
              <label>Notes</label>
              <textarea
                name="notes"
                rows="3"
                value={formData.notes}
                onChange={handleChange}
                placeholder="Additional deal notes..."
              />
            </div>
          </div>

          {/* FOOTER */}
          <div className="form-footer">
            <button type="button" className="btn-outline" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={isLoading}>
              <Save size={16} />
              {isLoading ? "Saving..." : "Save Deal"}
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
}